<template>
  <div>
    <div class="flex items-start">
      <div class="flex rounded-md shadow-sm flex-grow">
        <ResizeAuto>
          <template v-slot="{resize}">
            <textarea rows="1"
              class="form-textarea block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 resize-none overflow-y-none"
              tabindex="2"
              v-model="proposedBody"
              name="body"
              ref="proposedBody"
              @input="resize"
            ></textarea>
          </template>
        </ResizeAuto>
      </div>
      <div>
        <div class="flex">
      <TranslationModalInput
        :homeLanguages="homeLanguages"
        :body="proposedBody"
        :hasTranslated="hasTranslated"
        v-on:input="didTranslate"
        class="ml-2"
      />
      <ImageModalInput
        :proposedMessageFile="proposedMessageFile"
        :teamId="teamId"
        :hasImaged="hasImaged"
        v-on:input="didImage"
        class="ml-2"
      />
      <span class="ml-2 shadow-sm rounded-md">
        <button
          type="button"
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-lg rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:ring-indigo focus:border-indigo-700 active:bg-indigo-700 transition duration-150 ease-in-out"
          tabindex="2"
          @click="didSubmit"
        >
          Send
        </button>
      </span>
        </div>
        <div
          class="text-right text-xs hidden sm:block"
          :class="{'text-red-700': isTooLong}"
        >
          {{originalCharacterCount}} / 320
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { tz }                 from '@/tz'
import _get                   from 'lodash-es/get'
import _map                   from 'lodash-es/map'

import ButtonSubmit           from '@/components/ButtonSubmit.vue'
import FilePicker             from '@/components/FilePicker.vue'
import GridInput              from '@/components/GridInput.vue'
import Modal                  from '@/components/Modal.vue'
import TranslationModalInput  from '@/components/TranslationModalInput.vue'
import ImageModalInput        from '@/components/ImageModalInput.vue'
import ResizeAuto             from '@/components/ResizeAuto.vue'

import MessageCreate          from '@/mutations/MessageCreate.gql'

export default {
  components: {
    ButtonSubmit,
    FilePicker,
    GridInput,
    ImageModalInput,
    Modal,
    ResizeAuto,
    TranslationModalInput,
  },

  props: {
    homeLanguages: {
      type: Array
    },
    homeNumberId: {
      type: String,
      required: true
    },
    moods: {
      type: Array,
      default: function() { return [] }
    },
    teamId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      hasImaged: false,
      hasTranslated: false,
      isSending: false,
      proposedBody: '',
      proposedHomeLanguage: null,
      proposedMessageFile: null,
      proposedMoods: [],
      proposedOriginalBody: null
    }
  },

  computed: {
    originalCharacterCount() {
      if (this.proposedBody) {
        return this.proposedBody.length
      } else {
        return 0
      }
    },

    hasTextOrImage() {
      return this.hasImaged || this.originalCharacterCount > 0
    },

    isTooLong() {
      return this.originalCharacterCount > 320
    },

    isValid() {
      return this.hasTextOrImage && !this.isTooLong
    },

    messageParams() {
      return {
        body: this.proposedBody,
        homeLanguageId: _get(this.proposedHomeLanguage, 'id'),
        homeNumberId: this.homeNumberId,
        messageFileId: _get(this.proposedMessageFile, 'id'),
        moodIds: _map(this.proposedMoods, 'id'),
        originalBody: this.proposedOriginalBody,
        teamId: this.teamId,
        tz: tz()
      }
    }
  },

  methods: {

    didSubmit() {
      if (this.isValid) {
        this.isSending = true
        this.$apollo.mutate({
          mutation: MessageCreate,
          variables: this.messageParams
        }).then((data) => {
          console.log('Cardstock: MessageForm - Successful message submit')
          this.isSending = false
          this.proposedOrignalBody = null
          this.proposedBody = ''
          this.hasTranslated = false
          this.proposedHomeLanguage = null
          this.proposedMoods = []
          this.proposedMessageFile = null
        })
      } else {
        alert("Unable to send. Either attach an image or include a message between 1 and 320 characters")
      }
    },

    didImage({proposedMessageFile, hasImaged}) {
      this.proposedMessageFile = proposedMessageFile
      this.hasImaged = hasImaged
    },

    didSelectMoods(moods) {
      this.proposedMoods = moods
    },

    didTranslate({homeLanguage, translatedBody, hasTranslated}) {
      if (hasTranslated) {
        this.proposedOriginalBody = this.proposedBody
        this.proposedBody = translatedBody
      } else {
        this.proposedBody = this.proposedOriginalBody
        this.proposedOriginalBody = null
      }

      this.proposedHomeLanguage = homeLanguage
      this.hasTranslated = hasTranslated
      this.$refs.proposedBody.focus()
    }
  },

  watch: {
    proposedBody() {
      if (this.proposedBody == '' && this.proposedOriginalBody !== null) {
        this.proposedOriginalBody = null
        this.proposedHomeLanguage = null
        this.hasTranslated = false
      }
    }
  }
}
</script>
